import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';

export const autoSessionBridge = {
  /**
   * `epoch` is the account epoch captured when Rust asked for this token (the
   * `chronicle:auto_session_token_needed` payload, or `accountTransition`'s
   * return value). Rust rejects the write if the account has since switched.
   */
  async provideAuth(token: string, baseUrl: string, epoch: number): Promise<void> {
    if (!isTauri()) return;
    try {
      const { invoke } = await import('@tauri-apps/api/core');
      await invoke('auto_session_provide_auth', { token, baseUrl, epoch });
    } catch (error) {
      logger.error('[autoSessionBridge] Failed to provide auth:', error);
    }
  },

  async clearAuth(): Promise<void> {
    if (!isTauri()) return;
    try {
      const { invoke } = await import('@tauri-apps/api/core');
      await invoke('auto_session_clear_auth');
    } catch (error) {
      logger.error('[autoSessionBridge] Failed to clear auth:', error);
    }
  },

  async getOrWaitSession(): Promise<string | null> {
    if (!isTauri()) return null;
    try {
      const { invoke } = await import('@tauri-apps/api/core');
      return await invoke<string | null>('auto_session_get_or_wait');
    } catch (error) {
      logger.error('[autoSessionBridge] Failed to get auto-session:', error);
      return null;
    }
  },

  async setCurrentRouteSession(sessionId: string | null): Promise<void> {
    if (!isTauri()) return;
    try {
      const { invoke } = await import('@tauri-apps/api/core');
      await invoke('auto_session_set_current_route_session', { sessionId });
    } catch (error) {
      logger.error('[autoSessionBridge] Failed to set current route session:', error);
    }
  },
};
